import styled from 'styled-components';
import SearchTitle from './components/SearchTitle';
import FiltersMenuContainer from './components/filters-menu/FiltersMenuContainer';
import SearchBar from './components/search-bar/SearchBar';
import SortByContainer from '../search/components/search-filters/sort-by-input/SortByContainer';
import { useContext, useState } from 'react';
import { SearchContext, SearchContextInterface } from './context/SearchContext';
import { SearchFiltersTypes } from '../../reducers/search-filters/reducer';
import { useTranslation } from 'next-i18next';
import ArrowSwitchIcon from '../../new-components/svg-icons/ArrowSwitchIcon';
import { SearchFiltersActionTypes } from '../../reducers/search-filters/actions';
import SearchResults from './components/SearchResults';
import { updateQuery } from '../../helpers/common';
import { useRouter } from 'next/router';
import AreasFilter from './components/AreasFilter';
import Breadcrumbs from '../../new-components/Breadcrumbs';
import { logEvent } from '../../new-lib/analytics';
import { EntityTypes } from '../../new-lib/constants/common';
import ViewOnMapBtn from './components/ViewOnMapBtn';
import { resetFilter } from '../../helpers/search-filters';
import { useSorting } from './hooks/Sorting.hooks';

interface SearchViewProps {
  loadedSearchResultsSSR: any;
  resultsCount: number | null;
}

const SearchView = ({ resultsCount }: SearchViewProps) => {
  const [stackDropdown, setStackDropdown] = useState(false);
  const [stackSort, setStackSort] = useState(false);

  const { t } = useTranslation(['search', 'common']);
  const { searchFiltersDispatch, searchFiltersState } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const router = useRouter();
  const { sorting } = useSorting();

  const getToggleBtnText = () => {
    const switchType =
      searchFiltersState.searchFilters.category == 'property'
        ? 'compounds'
        : 'properties';

    return `${t('switch_to')} ${t(`${switchType}`)}`;
  };

  const handleCategoryToggle = () => {
    // resetFilter(SearchFiltersTypes.SORT_BY, searchFiltersDispatch, router);
    const value =
      searchFiltersState.searchFilters.category == 'property'
        ? 'compound'
        : 'property';
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_SORTING_ORDER,
      payload: {
        order_by: '',
        order_direction: ''
      }
    });
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
      payload: {
        name: SearchFiltersTypes.CATEGORY,
        value: value
      }
    });
    logEvent.click('search_switch', 'search_page', 'toggle_btn', {
      entity_type:
        value == 'property' ? EntityTypes.PROPERTY : EntityTypes.COMPOUND
    });

    updateQuery(
      router,
      [{ name: SearchFiltersTypes.CATEGORY, value }],
      ['sort_by']
    );
  };

  const getBreadcrumbs = () => {
    const breadcrumbItems = [
      {
        displayedName: `${
          searchFiltersState.searchFilters.category == 'compound'
            ? t('compounds')
            : t('properties')
        } ${t('in', { ns: 'common' })} ${t('egypt', { ns: 'common' })}`,
        path: `/search?${new URLSearchParams(
          router.query as Record<string, string>
        ).toString()}`
      }
    ];
    return <Breadcrumbs itemsToShow={breadcrumbItems} />;
  };

  return (
    <SearchLayout className="container-fluid">
      <div className="breadcrumbs">{getBreadcrumbs()}</div>
      <StickySearchHeader
        id="sticky-search-header"
        stackDropdown={stackDropdown}
        stackSort={stackSort}
      >
        <div className="search-input-container">
          <SearchBar setStackDropdown={setStackDropdown} />
        </div>
        <SortByContainer
          searchFiltersDispatch={searchFiltersDispatch}
          searchFiltersState={searchFiltersState}
          sortByOptions={sorting}
          sortLocation="search_page"
          setStackSort={setStackSort}
        />
        <ViewOnMapBtn />

        <button className="toggle-btn" onClick={handleCategoryToggle}>
          {getToggleBtnText()} <ArrowSwitchIcon />
        </button>
      </StickySearchHeader>
      <SearchTitle resultsCount={resultsCount} />
      <AreasFilter />
      <SearchBody>
        <div className="filters-section hide-scrollbar">
          <FiltersMenuContainer />
        </div>
        <SearchResults />
      </SearchBody>
    </SearchLayout>
  );
};

const SearchLayout = styled.div`
  display: flex;
  flex-direction: column;

  .sub-areas-container {
    display: flex;
    align-items: center;
    min-height: 50px;
  }
`;

const StickySearchHeader = styled.div<any>`
  position: sticky;
  top: 70px;
  padding: 10px 0;
  ${props =>
    props.stackDropdown || props.stackSort ? 'z-index: 100' : 'z-index: 0'};
  background-color: #fff;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  .search-input-container {
    flex: 1;
    height: 100%;
  }

  button.toggle-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    font-family: materialRegular;
    font-size: 14px;
    background-color: transparent;
    color: #5b6573;
    border: 1px solid #c6d0de;
    border-radius: 12px;
    cursor: pointer;
    height: 100%;
    gap: 8px;
  }
`;

const SearchBody = styled.div`
  position: sticky;
  left: 0;
  top: 200px;
  display: flex;
  flex-direction: row;
  background-color: #fff;
  padding-top: 24px;
  gap: 24px;
  height: 800px;
  .filters-section {
    width: 25%;
    height: 100%;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export default SearchView;
